import {Dimensions, StyleSheet} from 'react-native';

import {TAB_BAR_HEIGH} from '/component/layout/TabLayout/TabLayout.style';
import {indent} from '/constant/layout.constant';
import {grey80, white} from '/theme/color/on.color';
import {
  alto,
  darkRed,
  kimberlyLighter,
  salmonPink,
  wineRed,
} from '/theme/color/secondary.color';
const height = Dimensions.get('window').height;

export const styles = StyleSheet.create({
  mainView: {
    flex: 3,
  },
  base: {
    flex: 1,
    backgroundColor: white,
    overflow: 'hidden',
    overflowY: 'hidden',
    overflowX: 'hidden',
  } as any,
  webScrollContainer: {
    flex: 1,
    minHeight: 0,
    height: '100%',
    maxHeight: '100dvh',
    overflowY: 'scroll',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
    paddingBottom: TAB_BAR_HEIGH,
    overscrollBehavior: 'contain',
  } as any,
  contentContainer: {
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  header: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 16,
    marginTop: indent * 0.5,
    paddingLeft: indent,
  },
  label: {
    paddingLeft: indent,
    marginBottom: indent * 0.1,
  },
  inputBox: {
    borderWidth: 1,
    borderColor: alto,
    backgroundColor: white,
    width: '90%',
    marginLeft: indent * 1,
    borderRadius: indent * 0.4,
    marginBottom: indent * 1,
    height: 50,
  },
  inputText: {
    paddingLeft: indent * 0.5,
  },
  inputError: {
    borderColor: salmonPink,
    marginBottom: indent * 0.1,
    height: 50,
  },
  errorLabel: {
    paddingLeft: indent * 1,
    marginBottom: 12,
    color: darkRed,
  },
  trashIcon: {
    color: wineRed,
    fontSize: 16,
  },
  textStyle: {
    fontWeight: '700',
    color: '#000',
    fontSize: 14,
  },
  removetextStyle: {
    fontWeight: '700',
    color: wineRed,
    fontSize: 14,
  },

  modal: {
    backgroundColor: grey80,
    width: '100%',
    margin: 0,
  },
  modalView: {
    height: height > 684 ? '40%' : '70%',
    marginTop: 'auto',
    backgroundColor: white,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  modalHeader: {
    flexDirection: 'row',
    padding: 10,
    marginTop: 10,
  },
  modalBody: {
    flexDirection: 'column',
    padding: 10,
    margin: 10,
    marginLeft: 30,
  },
  headerText: {
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 10,
  },
  bodyText: {
    fontSize: 14,
    fontWeight: '400',
  },
  modalFooter: {
    flexDirection: 'column',
  },

  buttonBox: {
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: kimberlyLighter,
    width: '80%',
    marginLeft: indent * 2,
    borderRadius: indent * 0.4,
    marginBottom: indent * 1,
    height: 40,
  },
  deleteButtonContainer: {
    marginBottom: 20,
  },
  content: {
    flexGrow: 1,
  },
});
